export const SESSION_VARS = {
    MENU: "SESSION_MENU",
    TOKEN: "x-token",
    EMAIL: "email",
    CURRENT_COMPANY: "currentCompany",
    USERNAME: "username",
    BEARER_PREFIX: 'Bearer ',
    OAUTH2_TOKEN: "OAUTH2_TOKEN"
};

export const ActivityType = {
    VOUCHER: "VO",
    VEHICLE_TYPES: "TV",
    PAY_TYPES: "TP",
};

export const DETAILS_STATUS = {
    A: { code: "A", description: "Activo" },
    D: { code: "D", description: "Eliminado" },
    S: { code: "S", description: "Suspendido" },
    B: { codE: "B", description: "Bloqueado" },
};


export const STATUS = {
    ACTIVE: "A",
    DELETED: "D",
    ENABLED: "E",
    DISABLED: "U",
};

export const COMPANY_MAIN_CODE = 1;
export const KINDS = {
    INCOME_TYPES: { code: 21 },
};

export const entityType = {
    NATURAL_PERSON: 63
};
export const integrationTypes = {
    NOVASOFT_SHT: 'NOVASOFT_SHT',
    WORLDOFICCE_HIC: 'WORLDOFFICE_HIC',
    WORLDOFICCE_YOPAL: 'WORLDOFFICE_YOPAL',
    HELISA: 'HELISA',
    NAVISION: 'NAVISION'
};

/**
 * Tipos de tarifa
 * @type {{DAY_OUT: string}}
 */
export const tariffTypes = {
    DAY_OUT: "PD"
}
export const VEHICLE_TYPE = {
    BI: { code: "BI", description: "Bicicleta" },
    CA: { code: "CA", description: "Carro" },
    MT: { code: "MT", description: "Moto" },

};
export const TYPE_MOVMENTS = {
    ROTA: { code: "ROTA", description: "Rotación" },
    SUB: { code: "SUB", description: "Abonado" },
}

export const companySettingTypes = {
    PLATE_COMPARISON: { title: "plate_comparison" },
    CUMULATIVE_DISCOUNTS: { title: "cumulative_discounts" },
}
export const reportNames = {
    INTEGRATIONS: {
        FIDUCIARY_BANCOLOMBIA: { title: "Fiduciaria_bancolombia" },
        SHT_PRODUCTION: { title: "Reporte_producción_sht" },
        SHT_CLIENTS: { title: "Reporte_clientes_sht" },
        HELISA_TRANSACTIONS: { title: "Reporte_movimiento_contable" },
        HELISA_THIRD_PARTIES: { title: "Reporte_creación_terceros" },
        CONTAI_NITS: { title: "NIT PAR" },
        CONTAI_MOVEMET: { title: "FACTURACION PARQUEADERO" },
        WORLDOFICCE_YOPAL: "Reporte contable WorldOffice",
    },
    PARKING: {
        COLLECTION: { title: "Consolidado de Recaudos diarios" },
        COLLECTION_DETAIL: { title: "Consolidado Detallado de Recaudos diarios" },
    },
}
export const axiosFileExtensions = {
    XLSX: {
        extension: '.xlsx',
        response: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    TXT: {
        extension: '.txt',
        response: 'text/plain'
    },
    PDF: {
        extension: '.pdf',
        response: 'application/pdf'
    }
}
